export default "__VITE_ASSET__EHeO$CJF__"